import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const bannerSelector = createFeatureSelector<IState>('banner');
export const getBannersSelector = createSelector(bannerSelector, (state: IState) => state); 

